/* tslint:disable */
/* eslint-disable */
/**
 * My Title
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ObservableLevelResponse
 */
export interface ObservableLevelResponse {
    /**
     * 
     * @type {number}
     * @memberof ObservableLevelResponse
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ObservableLevelResponse
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ObservableLevelResponse
     */
    description?: string;
}

/**
 * Check if a given object implements the ObservableLevelResponse interface.
 */
export function instanceOfObservableLevelResponse(value: object): value is ObservableLevelResponse {
    return true;
}

export function ObservableLevelResponseFromJSON(json: any): ObservableLevelResponse {
    return ObservableLevelResponseFromJSONTyped(json, false);
}

export function ObservableLevelResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ObservableLevelResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function ObservableLevelResponseToJSON(json: any): ObservableLevelResponse {
    return ObservableLevelResponseToJSONTyped(json, false);
}

export function ObservableLevelResponseToJSONTyped(value?: ObservableLevelResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'description': value['description'],
    };
}

